
const NoValueErr = () => <span className="validation-err">*required field</span>;

export default NoValueErr;
